export class EventListener {
  constructor(handler) {
    this.handler = handler;
  }
  handleEvent(event) {
    this.handler(event);
  }
}

export class EventDispatcher {
  listeners = {};
  dispatch = (type, event = {}) => {
    const typeListeners = this.listeners[type] || [];
    typeListeners.forEach(listener => {
      listener.handleEvent(event);
    });
  };
  subscribe = (type, callable) => {
    const typeListeners = this.listeners[type] || [];
    const listener = new EventListener(callable);
    typeListeners.push(listener);
    this.listeners[type] = typeListeners;
    return listener;
  };
  unsubscribe = (type, listener) => {
    const typeListeners = this.listeners[type] || [];
    const listenerIdx = typeListeners.indexOf(listener);
    if (listenerIdx !== -1) {
      this.listeners[type] = [
        ...typeListeners.slice(0, listenerIdx),
        ...typeListeners.slice(listenerIdx + 1)
      ];
    }
  };
}